import React, { Fragment } from "react";
import { components } from "react-select";
//
import {
    Typography,
    Box,
    Paper,
    MenuItem,
    TextField,
    Tooltip,
} from "@material-ui/core";
import { HelpOutline as HelpOutlineIcon } from "@material-ui/icons";

const CrossIcon = components.CrossIcon;
const DownChevron = components.DownChevron;
const MenuListSelect = components.MenuList;

export function ClearIndicator(props) {
    return (
        <div {...props.innerProps} className={props.selectProps.classes.indicator}>
            {props.children || <CrossIcon />}
        </div>
    );
};

export function DropdownIndicator(props) {
    return (
        <div {...props.innerProps} className={props.selectProps.classes.indicator}>
            {props.children || <DownChevron />}
        </div>
    );
};

export function NoComponent() {
    return null;
}

export function IndicatorsContainer(props) {
    return <div className={props.selectProps.classes.indicatorsContainer}>{props.children}</div>;
}

export function NoOptionsMessage(props) {
    return (
        <Typography
            color="textSecondary"
            className={props.selectProps.classes.noOptionsMessage}
            {...props.innerProps}
        >
            {props.children}
        </Typography>
    );
}

export function inputComponent({ inputRef, ...props }) {
    return <div ref={inputRef} {...props} />;
}

export function Control(props) {
    return (
        <TextField
            label={props.selectProps.label}
            error={props.selectProps.error}
            helperText={props.selectProps?.helperText}
            className={props.selectProps.isDisabled ? props.selectProps.classes.inputDisabled : ""}
            variant="filled"
            fullWidth
            InputLabelProps={{
                shrink: props.isFocused || props.hasValue,
            }}
            InputProps={{
                inputComponent,
                inputProps: {
                    className: props.selectProps.classes.input,
                    inputRef: props.innerRef,
                    children: props.children,
                    ...props.innerProps,
                },
            }}
            {...props.selectProps.textFieldProps}
        />
    );
}

export function Option(props) {
    return (
        <MenuItem
            ref={props.innerRef}
            selected={props.isFocused}
            component="div"
            style={{
                fontWeight:
                    props.isSelected ||
                    isSelected(props.data, props.getValue(), props.selectProps.optionIdentifier)
                        ? 500
                        : 400,
                paddingLeft: "8px",
            }}
            title={
                props.children && typeof props.children === "string" && !props.data.hint
                    ? props.children
                    : null
            }
            {...props.innerProps}
        >
            <Fragment>
                {props.data.icon}
                <div style={{ textOverflow: "ellipsis", overflow: "hidden" }}>{props.children}</div>
                {props.data.hint && (
                    <Box color="text.secondary" marginLeft="auto" width={24} height={24}>
                        <Tooltip title={props.data.hint} placement="top">
                            <HelpOutlineIcon />
                        </Tooltip>
                    </Box>
                )}
            </Fragment>
        </MenuItem>
    );
}

export function isSelected(option, valueArray, optionIdentifier) {
    const value = valueArray && valueArray[0];

    if (option === value) {
        return true;
    }

    return (
        value &&
        option &&
        optionIdentifier &&
        optionIdentifier(option.value) === optionIdentifier(value.value)
    );
}

export function SingleValue(props) {
    return (
        <Typography
            className={"autoSuggest--valueContainer " + props.selectProps.classes.singleValue}
            title={props.children && typeof props.children === "string" ? props.children : null}
            {...props.innerProps}
        >
            {props.data.icon}
            {props.children}
        </Typography>
    );
}

export function ValueContainer(props) {
    return <div className={props.selectProps.classes.valueContainer}>{props.children}</div>;
}

export function MenuList(props) {
    return (
        <MenuListSelect {...props} className={props.selectProps.classes.menuList}>
            {props.children}
        </MenuListSelect>
    );
}

export function Menu(props) {
    return (
        <Paper square className={props.selectProps.classes.paper} {...props.innerProps}>
            {props.children}
        </Paper>
    );
}